import * as yup from 'yup';

import { DocumentNumberTypeEnum } from 'src/modules/UserIdentity/constants/identityParams';
import { getDocumentNumberSchema } from 'src/modules/UserIdentity/utils/documentNumberUtils/getDocumentNumberSchema';

export const useSchema = (documentNumberType: DocumentNumberTypeEnum) =>
  yup.object({
    documentNumber: getDocumentNumberSchema(documentNumberType)
  });
